export class CareLinePriorityStatusRequest {
    public idCareLinePriority: number;
    public idCareLinePriorityStatus: number;
    public careLinePriorityStatusMotive: string;
}